// used in pdp , plp , related , upsell etc
export const StoreAttributes = `
  is_bulk_product,
  subtitle
  ooka_product_type
  is_custom_kit
  is_bundle_options_hidden
  certificate_of_analysis
`
